
  let swiperInfoMain = null;

  function initInfoMainSwiper() {
    if (window.innerWidth < 768) {
      if (!swiperInfoMain) {
        swiperInfoMain = new Swiper('.info__main__slider', {
          slidesPerView: 'auto',
          spaceBetween: 16,
          loop: false,
          speed: 800,
          pagination: {
            el: '.info__main__slider-pagination',
            clickable: true,
          },
          // autoplay: {
          //   delay: 4000,
          //   disableOnInteraction: false,
          // },
        });
      }
    } else {
      if (swiperInfoMain) {
        swiperInfoMain.destroy(true, true);
        swiperInfoMain = null;
      }
    }
  }

  initInfoMainSwiper();
  window.addEventListener('resize', initInfoMainSwiper);